function getConfigCompoment () { return 'YMConfigCompoment' }
function getStandardAttributes () {
  return []
}

export default {
  hasExecutions: () => true,
  getConfigCompoment,
  getStandardAttributes
}
